export default __webpack_public_path__ + "static/collage-7-928c961923a2db8273c47a88b774b756.jpg";